type ProjectAdmin = {
	loading: boolean;
	isProjectAdmin: boolean | null;
} | null;
let projectAdmin: ProjectAdmin = null;
/**
 * Determines if the current context is within a project's administrative scope. It identifies
 * whether the admin status is actively being determined (loading), is indeterminate, or
 * confirms the user's administrative privileges within the project.
 */
export const getIsProjectAdmin = (): string | boolean => {
	// Initialised as null, this likely means we aren't in a
	// project route and the listener hasn't been rendered
	if (projectAdmin == null || (!projectAdmin.loading && projectAdmin.isProjectAdmin == null)) {
		return 'UNKNOWN';
	}
	if (projectAdmin.loading === true) {
		return 'LOADING';
	}
	return Boolean(projectAdmin.isProjectAdmin);
};
export const setIsProjectAdmin = (projectAdminState: ProjectAdmin): void => {
	projectAdmin = projectAdminState;
};
